<template>
   <div>
       <homen></homen>
        <xuanfu class="pcshow"></xuanfu>
         <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/speaker.jpg" alt="">
                <img class="mshow" src="../assets/images/mspeaker.png" alt="">
                <div class="title">
                <div class="titlep">
                        <h3>SPEAKERS</h3>
                        <h4>演讲嘉宾</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <h2>Keynote Speakers</h2>
                    <div class="miaodian">
                        <ul>
                            <li @click="Business">Business Leaders</li>
                            <li @click="Experts">Cross-Border Experts</li>
                            <li @click="Leading">Leading Professionals</li>
                            <li @click="TopScholars">Top Scholars</li>                            
                        </ul>
                    </div>
                    <div class="speakerboxs">
                        <ul class="clear">
                            <li v-for="(KeynoteSpeaker,id) in KeynoteSpeakers" :key="id">
                                <a @click="toBio(KeynoteSpeaker,id)" href="javascript:;"><img :src="KeynoteSpeaker.urlImg" alt=""></a>
                                <h6>{{KeynoteSpeaker.name}}</h6>
                                <p>{{KeynoteSpeaker.title}}</p>
                            </li>
                        </ul>
                    </div>
                     <h3 id="qylx">Business Leaders</h3>
                    <div class="speakerboxs">
                        <ul class="clear">
                            <li v-for="(BusinessLeader,id) in BusinessLeaders" :key="id">
                                <a @click="toBio1(BusinessLeader,id)" href="javascript:;"><img :src="BusinessLeader.urlImg" alt=""></a>
                                <h6>{{BusinessLeader.name}}</h6>
                                <p>{{BusinessLeader.title}}</p>
                            </li>
                        </ul>
                    </div>
                    <h3 id="kjzj">Cross-Border Experts</h3>
                    <div class="speakerboxs">
                        <ul class="clear">
                            <li v-for="(CrossBorderExpert,id) in CrossBorderExperts" :key="id">
                                <a @click="toBio2(CrossBorderExpert,id)" href="javascript:;"><img :src="CrossBorderExpert.urlImg" alt=""></a>
                                <h6>{{CrossBorderExpert.name}}</h6>
                                <p>{{CrossBorderExpert.title}}</p>
                            </li>
                        </ul>
                    </div>
                    <h3 id="hyxf">Leading Professionals</h3>
                    <div class="speakerboxs">
                        <ul class="clear">
                             <li v-for="(LeadingProfessional,id) in LeadingProfessionals" :key="id">
                                <a @click="toBio3(LeadingProfessional,id)" href="javascript:;"><img :src="LeadingProfessional.urlImg" alt=""></a>
                                <h6>{{LeadingProfessional.name}}</h6>
                                <p>{{LeadingProfessional.title}}</p>
                            </li>
                        </ul>
                    </div>
                    <h3 id="xjtd">Top Scholars</h3>
                    <div class="speakerboxs">
                        <ul class="clear">
                            <li v-for="(TopScholarsdata,id) in TopScholarsdatas" :key="id">
                                <a @click="toBio4(TopScholarsdata,id)" href="javascript:;"><img :src="TopScholarsdata.urlImg" alt=""></a>
                                <h6>{{TopScholarsdata.name}}</h6>
                                <p>{{TopScholarsdata.title}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <wrapright></wrapright>
            </div>
        </div>
       <foot></foot>
   </div>
</template>

<script>
    import xuanfu from '@/components/commn/xuanfu'
    import homen from '@/components/commn/homen'
    import foot from '@/components/commn/foot'
    import wrapright from '@/components/commn/wrapright'
    export default {
        components:{
            xuanfu,
            homen,
            foot,
            wrapright
        },
        metaInfo: {
            title: 'speakers  - 42nd International Congress on Assessment Center Methods and Developing Leadership Talent',
            meta: [
                {
                    name: 'keywords',
                    content: '42nd International Congress on Assessment Center Methods and Developing Leadership Talent; Leadership Development Forum'
                },
                {
                    name: 'description',
                    content: 'The Keynote speaker at the 42nd International Congress on Assessment Center Methods and Developing Leadership Talent is DDI founder William C. Byham Ph.D and  general manager of Human resource from microsoft asia'
                }
            ]
        },
        data () {
            return {
                KeynoteSpeakers:[],
                BusinessLeaders:[],
                CrossBorderExperts:[],
                LeadingProfessionals:[],
                TopScholarsdatas:[],
            }
        },
        mounted () {
            window.addEventListener("scroll", this.handleScroll, true);
        },
        methods: {
            toBio(item,id) {
            this.$router.push({ 
                path: '/brief_en', 
                query:{ detail:item.Id}})//跳转个人简介
        },
        toBio1(item,id) {
            this.$router.push({ 
                path: '/brief_en', 
                query: { detail: item.Id }})//跳转个人简介
        },
        toBio2(item,id) {
            this.$router.push({ 
                path: '/brief_en', 
                query: { detail: item.Id }})//跳转个人简介
        },
        toBio3(item,di) {
            this.$router.push({ 
                path: '/brief_en', 
                query: { detail: item.Id }})//跳转个人简介
        },
        toBio4(item,id) {
            this.$router.push({ 
                path: '/brief_en', 
                query: { detail: item.Id }})//跳转个人简介
        },
            getBio () {
                this.axios({
                    method: "post",
                    url: "https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=1",
                })
                .then(res=> {
                    console.log(res)
                    this.KeynoteSpeakers = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio1 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=4"
                })
                .then(res=> {
                    this.BusinessLeaders = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio2 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=5"
                })
                .then(res=> {
                    this.CrossBorderExperts = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio3 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=3"
                })
                .then(res=> {
                    this.LeadingProfessionals = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio4 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=2"
                })
                .then(res=> {
                    this.TopScholarsdatas = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            // 定位到分类位置
            handleScroll () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // console.log(scrollTop);
            },
            TopScholars () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                document.getElementById('xjtd').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});  
            },
            Leading () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                document.getElementById('hyxf').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});       
            },
            Business () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                document.getElementById('qylx').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});       
            },
            Experts () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                document.getElementById('kjzj').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});      
            }
        },
         created() {
          this.getBio ()
          this.getBio1 ()
          this.getBio2 ()
          this.getBio3 ()
          this.getBio4 ()
      }
    }
</script>

<style scoped>
     @import url('../assets/css/inpublic.css');
     @media screen and (max-width:768px) {
          .miaodian ul li {
            width: 50%;
        }
     }
</style>



// WEBPACK FOOTER //
// src/components/speakers_en.vue